import { taxonomyAPI } from '@/providers/apis/taxonomy/taxonomy';
import { tenantSettingsAPI } from '@/providers/apis/tenant-settings/tenant-settings';
import { Vue, Component, Prop } from 'vue-property-decorator';
import TxCategoryPrefer from '../tx-category-prefer/tx-category-prefer';
import TxFwPrefer from '../tx-fw-prefer/tx-fw-prefer';
import TxSubjectPrefer from '../tx-subject-prefer/tx-subject-prefer';

@Component({
    name: 'tx-loader',
    components: {
        'tx-category': TxCategoryPrefer,
        'tx-subject': TxSubjectPrefer,
        'tx-fw': TxFwPrefer,
    },
})

export default class TxLoader extends Vue {

    // --------------------------------------------------------------------------
    // Properties

    private componentList: any = [
        {
            name: 'Categories',
            key: 'tx-category',
        },
        {
            name: 'Subjects',
            key: 'tx-subject',
        },
        {
            name: 'Frameworks',
            key: 'tx-fw',
        },
    ];
    private activeComponent: string = 'tx-category';

    private activeValue: any;

    @Prop()
    private contentLoader: any;

    @Prop()
    private selectedConfig: any;

    @Prop()
    private tenantSettings: any;

    private get activeIndex() {
        return this.componentList.findIndex((item: any) => item.key === this.activeComponent);
    }

    // ---------------------------------------------------------------------------
    // Hooks
    private created() {
        const tenantConfig = this.tenantSettings.find((item: any) => item.key === 'tx_fw_prefs');
        if (tenantConfig && tenantConfig.value) {
            this.activeComponent = 'tx-fw';
        }
    }

    // -----------------------------------------------------------------------------
    // Actions

    private onGoNext(keys: string, value: any) {
        this.activeComponent = keys;
        this.activeValue = value;
    }

    private onChangeConfig(keys: string, config: any) {
        const payload = {
            tenant_key: keys,
            value: (typeof config === 'object' ? JSON.stringify(config) : config),
        };
        // this.updateConfig(payload);
    }



    // --------------------------------------------------------------------------------
    // Methods

    private updateConfig(config: any) {
        // tenantSettingsAPI.updateTenantSettings(config).then(() => {
        //     this.$store.dispatch('tenantStore/fetchTenantSettings');
        // });
    }
}
